export default {
	device_subscriptions: "Device Subscriptions",
	has_subscription: "Has Subscription",
	is_online: "Is Online",
	expires_on: "Expires On",
	online: "Online",
	offline: "Offline",
	export_to_csv: "Export to CSV",
	device_subscriptions: "Device Subscriptions",
	no_results_matching: "No results matching",
	public_id_number: "Public ID Number",
};
